import React, {useEffect, useRef} from 'react';
import './VendorSettings.scss';
import {connect} from 'react-redux';
import {setFilter, setConsent, setObjectConsent} from '../../../../redux/actions';
import Vendors from "./Vendor/Vendors";
import useAvailableHeight from "../../../../hooks/useAvailableHeight";

const VendorSettings = props => {
    const {setFilter} = props;
    const settingsRef = useRef(null);
    const vendorsRef = useRef(null);
    const availableHeight = useAvailableHeight(settingsRef, vendorsRef);

    useEffect(() => {
        return function cleanup() {
            setFilter(null);
        }
    }, [setFilter]);

    const SelectedFilter = () => {
        const {name, descriptionLegal} = props.currentFilter?.value;

        // Separate into title and items for a list
        const [descTitle, ...descItems] = descriptionLegal
            .split(/\r\n|\r|\n/g)
            .map((value, index) => {
                return index === 0 ? value :
                    (<li className="description-item" key={`description_item_${index}`}>
                        {value.replace(/^\*\s*/, '')}
                    </li>);
            })

        return (
            <div id="filter">
                <h2 id="filterName">
                    {name}
                </h2>
                <div id="filterDescription">
                    <div className="description-title">
                        {descTitle}
                    </div>
                    <ul className="description-items">
                        {descItems}
                    </ul>
                </div>
            </div>
        );
    }

    return (
        <div id="vendorSettings" ref={settingsRef}>
            <SelectedFilter/>
            <Vendors vendorsRef={vendorsRef} availableHeight={availableHeight}/>
        </div>
    );
};

const mapStateToProps = state => {
    return {...state};
}

export default connect(mapStateToProps, {setFilter, setConsent, setObjectConsent})(VendorSettings);